import React, { createContext } from "react";
import Banner from "../../main/home/banner/Banner";

import CoursesMainContainer from "../../main/home/courses/CoursesMainContainer";
import HomePageMentors from "../../main/home/Mentors/Mentors";
import About from "../../main/home/about/About";
import ContactFormMain from "../../main/home/Contactform/ContactFormMain";
import TestimonialsMain from "../../main/home/Testimonials/Testimonials";
import Dialog from "../../main/funnel/dialog/Dialog";

const Home = () => {
   const MyContext = createContext("");
  return (
    <div className="">

      <Banner />
      <CoursesMainContainer />
      <HomePageMentors />
      <TestimonialsMain />
      <About />
      <ContactFormMain />
      <Dialog />
    </div>
  );
};

export default Home;
